export const MAX_RESPONSE_RANGE = 999999999;
export const MIN_RESPONSE_RANGE = -999999999;
export const PIE_CHART = 'Rose';
export const BAR_CHART = 'Bar';
export const TABLE_CHART = 'Table';
export const AVERAGE_CHART = 'AverageNumericResponse';
export const MOST_COMMON_CHART = 'MostCommonResponse';
export const RESPONSE_GIVEN = 'Response given';
export const NO_RESPONSE_GIVEN = 'No response given';
export const WORD_CLOUD = 'WordCloud';
export const WORD_COUNT = 'WordCount';
export const RESPONSE_CLOUD = 'ResponseCloud';
export const RESPONSE_COUNT = 'ResponseCount';
export const SELECT_TEXT = 'Select';

export const DEFAULT_STYLE_NAME = 'Default';


export enum ImportFromSystemType {
  TypeForm = 'TypeForm',
  SurveyMonKey = 'SurveyMonKey',
  CSV = 'CSV',
}

export const COMMON_LENGTH = {
  MAX_LENGTH_255: 255,
};



// WEBPACK FOOTER //
// ./src/app/shared/constants/input.constants.ts